<template lang="html">
  <div id="floorplan-detail-heading" class="pt3 pb4 mh3">
    <div class="flex items-start justify-between">
      <!-- Prev -->
      <div class="w4 tl">
        <v-link v-if="plan.prev"
          :label="plan.prev.name"
          icon-code="keyboard_arrow_left"
          icon-pos="left"
          icon-class="f5 b mt1"
          :route="{ name: 'FloorplanDetail', params: { id: plan.prev.id }}"
          class="bg-transparent hover-action ttc black b f6"
        />
      </div>

      <!-- Name -->
      <div class="dn ttc b flex-ns items-center">
        <span class="pointer nl4 mr2 favourite" @click="TOGGLE_FAVOURITE_PLAN(plan.current.id)" :class="{'invisible': favourites.length >= maxFavourites && !plan.current.favourited}">
          <i v-if="plan.current.favourited" class="material-icons interact-favourite">&#xE838;</i>
          <i v-else class="material-icons interact-favourite">&#xE83A;</i>
        </span>
        <span class="f3 font-futura-bold" v-html="plan.current.name"></span>
      </div>

      <!-- Next -->
      <div class="w4 tr">
        <v-link v-if="plan.next"
          :label="plan.next.name"
          icon-code="keyboard_arrow_right"
          icon-pos="right"
          icon-class="f5 b mt1"
          :route="{ name: 'FloorplanDetail', params: { id: plan.next.id }}"
          class="bg-transparent hover-action ttc black b f6"
        />
      </div>
    </div>
    <!-- Name mobile -->
    <div class="ttc b db dn-ns center mt3">
      <span class="pointer nl4 mr1" @click="TOGGLE_FAVOURITE_PLAN(plan.current.id)">
        <i v-if="plan.current.favourited" class="material-icons interact-favourite">&#xE838;</i>
        <i v-else class="material-icons interact-favourite">&#xE83A;</i>
      </span>
      <span class="f3 font-futura-bold" v-html="plan.current.name"></span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LinkComponent from '@/components/Link';

export default {
  name: 'floorplan-detail-heading',
  props: {
    plan: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    'v-link': LinkComponent
  },
  computed: {
    ...mapGetters(['favourites', 'maxFavourites'])
  },
  methods: {
    ...mapActions(['TOGGLE_FAVOURITE_PLAN']),
    handleArrowKeys(e) {
      if (!e.metaKey && e.keyCode === 39) {
        if (this.plan.next) {
          this.$router.push({ name: 'FloorplanDetail', params: { id: this.plan.next.id } });
        }
      } else if (!e.metaKey && e.keyCode === 37) {
        if (this.plan.prev) {
          this.$router.push({ name: 'FloorplanDetail', params: { id: this.plan.prev.id } });
        }
      }
    }
  },
  created() {
    window.addEventListener('keydown', this.handleArrowKeys);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleArrowKeys);
  }
};
</script>

<style lang="scss">
#floorplan-detail-heading {
  span.favourite {
    visibility: visible;
    &.invisible { visibility: hidden; }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanDetail/FloorplanDetailHeading.vue